import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Navbar } from "../../Components/Navbar/Navbar";
import { useParams } from "react-router-dom";
import i18next from "i18next";
import { Meta } from "../../Components/Helpers/Meta";
import "./Health.styles.css";
import {
  ShieldCheck,
  Activity,
  BookOpen,
  AlertTriangle,
  HardHat,
  Thermometer,
  Scale,
  Settings,
} from "lucide-react";

const ISGEnglish = () => {
  return (
    <div>
      <p>
        <strong>
          Occupational Health and Safety Management at Cevher Jant San. A.Ş.
        </strong>
      </p>
      <p>
        Cevher Jant Sanayii A.Ş., together with high-quality wheel production
        and customer satisfaction, adopts the health and safety of employees and
        the working environment as one of the cornerstones of sustainable
        development. There is no process excluded in terms of Occupational
        Health and Safety (OHS) in our company; OHS is evaluated as a priority
        in all processes. Cevher Jant San. A.Ş. holds the ISO 45001 Occupational
        Health and Safety Certificate. The OHS Management System is continuously
        improved. Within this scope;
      </p>
      <ul>
        <li>
          <p>Occupational Health and Safety risk management,</p>
        </li>
        <li>
          <p>Training and Awareness Activities,</p>
        </li>
        <li>
          <p>Compliance with legislation,</p>
        </li>
        <li>
          <p>
            Investigation of incidents, accidents, hazards and near-miss events
            and root cause analyses,
          </p>
        </li>
        <li>
          <p>Health</p>
        </li>
        <li>
          <p>Ergonomics</p>
        </li>
        <li>
          <p>Machine and Equipment Safety</p>
        </li>
        <li>
          <p>Periodic Inspections and Measurements</p>
        </li>
        <li>
          <p>Personal Protective Equipment (PPE)</p>
        </li>
        <li>
          <p>Chemical Management</p>
        </li>
        <li>
          <p>Sustainability Management</p>
        </li>
        <li>
          <p>Emergency</p>
        </li>
        <li>
          <p>Supplier and Contractor Management</p>
        </li>
        <li>
          <p>Audits,</p>
        </li>
        <li>
          <p>Other … activities are being carried out</p>
        </li>
      </ul>
      <p>Within the framework of customer requirements and legal compliance;</p>
      <p>
        <strong>Occupational Health and Safety Risk Management</strong>
      </p>
      <ul>
        <li>
          <p>
            An Occupational Health and Safety Committee is established, and
            monthly meetings are held.
          </p>
        </li>
        <li>
          <p>
            Risk analyses are carried out within the scope of OHS, and existing
            risk analyses are kept up to date.
          </p>
        </li>
        <li>
          <p>
            In risk prevention and protection activities, efforts are made
            primarily toward “elimination at the source,” which is the first
            stage.
          </p>
        </li>
      </ul>
      <p>
        <strong>Training and Awareness Activities</strong>
      </p>
      <ul>
        <li>
          <p>
            Training activities are managed within the framework of a procedure
            covering all trainings. OHS trainings are also included in this
            procedure, and there are many types of training (orientation,
            awareness raising, legal, vocational, post-accident, TNE, etc.).
          </p>
        </li>
        <li>
          <p>
            In the “Training Festival” program, which has become a tradition at
            Cevher Jant San. A.Ş., it is aimed to increase employees’ awareness
            of OHS not only within the company but also in their daily lives.
          </p>
        </li>
        <li>
          <p>
            Certifications required due to the employee or job requirements
            (Forklift License, Electric Pallet Truck Operator Certificate,
            Boiler Operator Certificate, etc.) are included in the training
            plan, and the acquisition of certificates is ensured.
          </p>
        </li>
        <li>
          <p>
            Vocational training needs are identified, and these needs are met.
          </p>
        </li>
        <li>
          <p>
            Awareness is increased through printed and visual materials within
            the scope of OHS.
          </p>
        </li>
        <li>
          <p>
            Various activities and competitions are organized during OHS Week,
            and the week is celebrated.
          </p>
        </li>
        <li>
          <p>
            During on-the-job orientation programs, Occupational Safety
            trainings are provided before actual work begins.
          </p>
        </li>
      </ul>
      <p>
        <strong>Compliance with Legislation</strong>
      </p>
      <ul>
        <li>
          <p>
            New situations and changes are evaluated within the scope of the
            change management procedure, and OHS-related requirements are
            determined.
          </p>
        </li>
        <li>
          <p>
            Laws and regulations are followed up-to-date, and changes affecting
            our factory are shared with the relevant departments and
            individuals.
          </p>
        </li>
      </ul>
      <p>
        <strong>
          Investigation of Incidents, Accidents, Hazards and Near-Miss Events
          and Root Cause Analyses
        </strong>
      </p>
      <ul>
        <li>
          <p>
            Incident investigations within the scope of OHS are carried out and
            recorded. A continuously improved system has been established
            regarding hazard and near-miss events.
          </p>
        </li>
        <li>
          <p>
            Within the scope of incident investigations, accident root cause
            analyses are conducted, actions are taken to eliminate identified
            risks, and their dissemination is ensured.
          </p>
        </li>
        <li>
          <p>
            Important OHS parameters (accident frequency rate, accident severity
            rate) are monitored, and department-based targets are set.
          </p>
        </li>
      </ul>
      <p>
        <strong>Employee Protection and Preventive Policies;</strong>
      </p>
      <p>
        <strong>Health</strong>
      </p>
      <ul>
        <li>
          <p>
            A full-time workplace physician is employed to ensure continuity of
            employee health services.
          </p>
        </li>
        <li>
          <p>
            A full-time auxiliary health personnel is employed to support health
            services.
          </p>
        </li>
        <li>
          <p>
            Under the supervision of the full-time Workplace Physician and other
            health personnel, infirmary services are provided, periodic health
            examinations of employees are carried out, and vaccinations are
            administered when necessary.
          </p>
        </li>
        <li>
          <p>
            A health surveillance plan is created on an employee basis, and
            monitoring controls are performed according to the working
            environment within this plan (chest X-ray, blood tests, audiometry
            measurement, pulmonary function test, etc.).
          </p>
        </li>
      </ul>
      <p>
        <strong>Ergonomics</strong>
      </p>
      <ul>
        <li>
          <p>
            During work, the ergonomics of the employee and the working area are
            examined, risk analyses are conducted, and actions are taken.
            Ergonomic conditions are continuously improved.
          </p>
        </li>
        <li>
          <p>
            Within the scope of ergonomics, workstations are evaluated, and
            adjustable desks, chairs, screens, and equipment are provided to
            employees.
          </p>
        </li>
        <li>
          <p>
            Manual handling tasks are arranged in accordance with ergonomic
            principles, and employees are trained on correct lifting, carrying,
            pushing and pulling techniques.
          </p>
        </li>
        <li>
          <p>
            Training and information activities are carried out to increase
            ergonomic awareness, and ergonomic improvement suggestions from
            employees are evaluated.
          </p>
        </li>
      </ul>
      <p>
        <strong>Machine and Equipment Safety</strong>
      </p>
      <ul>
        <li>
          <p>
            According to the Machinery Safety Regulation, machine safety starts
            from the purchasing stage; needs are identified, and requirements
            are fulfilled during installation, use, etc.
          </p>
        </li>
        <li>
          <p>
            Risk analyses are updated, and risks are identified with every new
            machine or equipment addition or relocation.
          </p>
        </li>
      </ul>
      <p>
        <strong>Periodic Inspections and Measurements</strong>
      </p>
      <ul>
        <li>
          <p>
            Periodic inspections of work equipment are carried out in accordance
            with relevant laws and annexes.
          </p>
        </li>
        <li>
          <p>
            Within the scope of Occupational Hygiene measurements, personal
            exposure and environmental measurements are conducted in the working
            environment to control employee exposure.
          </p>
        </li>
      </ul>
      <p>
        <strong>Personal Protective Equipment (PPE)</strong>
      </p>
      <ul>
        <li>
          <p>
            The use of personal protective equipment is adopted as the last
            resort to eliminate hazards and risks.
          </p>
        </li>
        <li>
          <p>
            The use of personal protective equipment is mandatory, and required
            PPEs are defined by documents on a job basis.
          </p>
        </li>
        <li>
          <p>
            Compliance with CE marking and EN standards is required in the
            selection of personal protective equipment.
          </p>
        </li>
      </ul>
      <p>
        <strong>Chemical Management</strong>
      </p>
      <ul>
        <li>
          <p>
            Employees are trained and made aware of chemicals and chemical risks
            within the scope of OHS.
          </p>
        </li>
        <li>
          <p>
            Company-specific summary Safety Data Sheets are kept in all areas
            where chemicals are present.
          </p>
        </li>
        <li>
          <p>
            A procedure for chemical management is in place, and the
            procurement, transportation, storage, and disposal of chemicals are
            controlled and recorded through procedures.
          </p>
        </li>
        <li>
          <p>
            The storage of chemicals is carried out in accordance with
            Environmental and OHS conditions.
          </p>
        </li>
        <li>
          <p>
            The transportation of chemicals by road is monitored within the
            framework of legal requirements.
          </p>
        </li>
        <li>
          <p>
            All rules regarding the packaging, labeling, temporary storage,
            internal transportation of chemicals and hazardous wastes, etc. are
            defined in documents and audited.
          </p>
        </li>
        <li>
          <p>
            Chemicals are evaluated within the scope of KKDIK and relevant
            legislation, and legal requirements are followed.
          </p>
        </li>
      </ul>
      <p>
        <strong>Sustainability Management</strong>
      </p>
      <ul>
        <li>
          <p>
            OHS performance is continuously improved in line with sustainability
            goals.
          </p>
        </li>
        <li>
          <p>The ISO 45001 OHS Management System Certificate is maintained.</p>
        </li>
        <li>
          <p>
            Continuous improvement tools (suggestion system, KAIZEN, lean six
            sigma, etc.) are used effectively.
          </p>
        </li>
      </ul>
      <p>
        <strong>Emergency</strong>
      </p>
      <ul>
        <li>
          <p>
            An Emergency Handbook is available, including customer requirements;
            identified risks such as occupational accidents, fire, earthquake,
            flood, food poisoning, sabotage, etc. are detailed, and the document
            is updated.
          </p>
        </li>
        <li>
          <p>
            Emergency plans and teams have been established, trainings are
            provided to teams, and drills are conducted.
          </p>
        </li>
        <li>
          <p>
            Fire is evaluated within the scope of emergency situations, and
            instructions are available. Fire-related systems and equipment are
            evaluated within the framework of legal requirements and standards.
          </p>
        </li>
      </ul>
      <p>
        <strong>Supplier and Contractor Management</strong>
      </p>
      <ul>
        <li>
          <p>
            Contractors are evaluated and audited in terms of OHS. Newly engaged
            suppliers are subject to evaluation.
          </p>
        </li>
        <li>
          <p>Contracts including OHS conditions are signed with contractors.</p>
        </li>
        <li>
          <p>
            Work permit procedures and instructions (hot work, working at
            height, etc.) have been prepared, and work permits are issued before
            such activities begin.
          </p>
        </li>
        <li>
          <p>Approved contractors are engaged.</p>
        </li>
      </ul>
      <p>
        <strong>Audit</strong>
      </p>
      <ul>
        <li>
          <p>
            Internal and external audits are conducted, and audit results are
            followed up with action plans.
          </p>
        </li>
      </ul>
      <p>
        <strong>Other</strong>
      </p>
      <ul>
        <li>
          <p>
            Participation and support are provided to the OHS activities of
            member organizations such as TÜDOKSAD and EBSO.
          </p>
        </li>
      </ul>
    </div>
  );
};

const ISGTurkish = () => {
  return (
    <div>
      <p>
        <strong>
          Cevher Jant San. A.Ş’de İş Sağlığı Ve Güvenliği Yönetimi
        </strong>
      </p>
      <p>
        Cevher Jant Sanayii A.Ş kaliteli jant üretimi ve müşteri memnuniyeti ile
        birlikte; çalışanın ve çalışma ortamının sağlığını ve güvenliğini de
        sürdürülebilir kalkınmanın temel taşlarından biri olarak
        benimsemektedir. Firmamızda İSG açısından kapsam dışı bırakılan bir
        süreç söz konusu değildir, süreçlerin tamamında İSG öncelikli olarak
        değerlendirilmektedir. Cevher Jant San. A.Ş. ISO 45001 İş Sağlığı ve
        Güvenliği belgesine sahiptir. İSG Yönetim Sistemi sürekli olarak
        iyileştirilmektedir. Bu kapsamda;
      </p>
      <ul>
        <li>
          <p>İş Sağlığı ve Güvenliği risk yönetimi,</p>
        </li>
        <li>
          <p>Eğitim ve Bilinçlendirme Çalışmaları,</p>
        </li>
        <li>
          <p>Yasalara uyum,</p>
        </li>
        <li>
          <p>
            Olay, kaza, tehlike ve ramak kala incelenmesi ve kök neden
            analizleri,
          </p>
        </li>
        <li>
          <p>Sağlık</p>
        </li>
        <li>
          <p>Ergonomi</p>
        </li>
        <li>
          <p>Makine ve Ekipman Emniyeti</p>
        </li>
        <li>
          <p>Periyodik Kontroller ve Ölçümler</p>
        </li>
        <li>
          <p>Kişisel Koruyucu Donanım (KKD)</p>
        </li>
        <li>
          <p>Kimyasal Yönetimi</p>
        </li>
        <li>
          <p>Sürdürülebilirlik Yönetimi</p>
        </li>
        <li>
          <p>Acil Durum</p>
        </li>
        <li>
          <p>Tedarikçi ve Yüklenici Yönetimi</p>
        </li>
        <li>
          <p>Denetim</p>
        </li>
        <li>
          <p>Diğer… çalışmaları yapılmaktadır.</p>
        </li>
      </ul>
      <p>Müşteri istekleri ve yasalara uyum çerçevesinde;</p>
      <p>
        <strong>İş Sağlığı ve Güvenliği Risk Yönetimi</strong>
      </p>
      <ul>
        <li>
          <p>
            İş Sağlığı ve Güvenliği Kurulu bulunmakta olup, aylık toplantılar
            yapılmaktadır.
          </p>
        </li>
        <li>
          <p>
            İş Sağlığı ve Güvenliği kapsamında risk analizleri yapılmakta,
            mevcut risk analizlerinin güncel kalması sağlanmaktadır.
          </p>
        </li>
        <li>
          <p>
            Risklerin önlenmesi ve koruma faaliyetlerinde; ilk aşama olan
            “kaynağında korumaya” yönelik çalışmalar yapılmaktadır.
          </p>
        </li>
      </ul>
      <p>
        <strong>Eğitim ve Bilinçlendirme Çalışmaları</strong>
      </p>
      <ul>
        <li>
          <p>
            Eğitim çalışmaları, tüm eğitimleri içeren prosedür çerçevesinde
            yönetilmektedir. İSG eğitimleri de bu prosedüre dahil olup, pek çok
            eğitim çeşidi bulunmaktadır (oryantasyon, bilinç artırma, yasal,
            mesleki, iş kazası sonrası, TNE vb.).
          </p>
        </li>
        <li>
          <p>
            Cevher Jant San. A.Ş. geleneği haline gelen “Eğitim Şenliği”
            programında İSG eğitimleri ile çalışanların bu konudaki bilinç
            seviyesi, sadece firma özelinde değil, günlük yaşantılarına da
            yansıyacak şekilde yükseltilmesi hedeflenmektedir.
          </p>
        </li>
        <li>
          <p>
            Çalışanın veya işin gereği oluşan sertifikasyon (Forklift Ehliyeti,
            Elektrikli Transpalet Operatörlük Belgesi, Kazan Operatörlük Belgesi
            vb.) işlemleri eğitim planına dahil edilmekte ve belgelerin alınması
            sağlanmaktadır.
          </p>
        </li>
        <li>
          <p>
            Mesleki eğitim ihtiyaçları belirlenmekte ve bu ihtiyaçların
            giderilmesi sağlanmaktadır.
          </p>
        </li>
        <li>
          <p>
            İSG kapsamında basılı ve görsel materyaller ile farkındalık
            artırılmaktadır.
          </p>
        </li>
        <li>
          <p>
            İSG haftasında çeşitli aktiviteler ve yarışmalar yapılmakta,
            haftanın kutlanması sağlanmaktadır.
          </p>
        </li>
        <li>
          <p>
            İş başı oryantasyon programlarında, fiili çalışmaya başlamadan önce
            İş Güvenliği eğitimleri gerçekleştirilmektedir.
          </p>
        </li>
      </ul>
      <blockquote>
        <p>
          <strong>Yasalara uyum</strong>
        </p>
      </blockquote>
      <ul>
        <li>
          <p>
            Yeni bir durum ve değişiklik, değişim yönetimi prosedürü kapsamında
            değerlendirilmekte ve İSG ile ilgili gereklilikler belirlenmektedir.
          </p>
        </li>
        <li>
          <p>
            Kanun ve yönetmelikler güncel olarak takip edilmekte, fabrikamızı
            ilgilendiren değişiklikler ilgili bölüm ve kişilerle
            paylaşılmaktadır.
          </p>
        </li>
      </ul>
      <p>
        <strong>
          Olay, kaza, tehlike ve ramak kala incelenmesi ve kök neden analizleri
        </strong>
      </p>
      <ul>
        <li>
          <p>
            İSG kapsamındaki olay araştırmaları yapılmakta ve kayıt altına
            alınmaktadır. Tehlike ve ramak kala olayları ile ilgili sürekli
            iyileştirilen bir sistem oluşturulmuştur.
          </p>
        </li>
        <li>
          <p>
            Olay incelemeleri kapsamında kaza kök neden analizleri yapılmakta,
            belirlenen risklerin ortadan kaldırılmasına yönelik aksiyonlar
            alınmakta ve yaygınlaştırılması sağlanmaktadır.
          </p>
        </li>
        <li>
          <p>
            İSG kapsamında önemli parametreler (kaza sıklık oranı, kaza ağırlık
            oranı) takip edilmekte, bölüm bazında hedefler konulmaktadır.
          </p>
        </li>
      </ul>
      <p>
        <strong>Çalışan koruma ve korunma politikaları;</strong>
      </p>
      <p>
        <strong>Sağlık</strong>
      </p>
      <ul>
        <li>
          <p>
            Çalışanların sağlık hizmeti devamlılığının sağlanması amacıyla tam
            zamanlı bir işyeri hekimi bulunmaktadır.
          </p>
        </li>
        <li>
          <p>
            Sağlık konusunda destek amacıyla tam zamanlı yardımcı sağlık
            personeli bulunmaktadır.
          </p>
        </li>
        <li>
          <p>
            Tam zamanlı İşyeri Hekimi ve diğer sağlık personeli kontrolünde
            revir hizmetleri verilmekte, çalışanların periyodik sağlık
            kontrolleri ve duruma göre aşılama işlemleri yapılmaktadır.
          </p>
        </li>
        <li>
          <p>
            Çalışan bazında sağlık kontrol planı oluşturulmakta ve bu plan
            doğrultusunda çalışma ortamına göre gözetim kontrolleri
            yapılmaktadır. (akciğer grafiği, kan tetkiki, odyometri ölçümü,
            solunum fonksiyon testi, vb.)
          </p>
        </li>
      </ul>
      <p>
        <strong>Ergonomi</strong>
      </p>
      <ul>
        <li>
          <p>
            Çalışma sırasında, çalışanın ve çalışma alanının ergonomisi
            incelenmekte, risk analizi yapılmakta ve aksiyonlar alınmaktadır.
            Ergonomik şartlar sürekli olarak iyileştirilmektedir.
          </p>
        </li>
        <li>
          <p>
            Ergonomi kapsamında çalışma istasyonları değerlendirilmekte,
            çalışanlara ayarlanabilir masa, sandalye, ekran, ekipman temin
            edilmektedir.
          </p>
        </li>
        <li>
          <p>
            Elle taşıma işleri ergonomi prensiplerine uygun olarak
            düzenlenmekte, çalışanlara doğru kaldırma, taşıma ve itme-çekme
            teknikleri konusunda eğitimler verilmektedir.
          </p>
        </li>
        <li>
          <p>
            Ergonomi farkındalığını artırmaya yönelik eğitim ve bilgilendirme
            çalışmaları yapılmakta, çalışanlardan gelen ergonomi iyileştirme
            önerileri değerlendirmeye alınmaktadır.
          </p>
        </li>
      </ul>
      <p>
        <strong>Makine ve Ekipman Emniyeti</strong>
      </p>
      <ul>
        <li>
          <p>
            Makine Emniyet Yönetmeliği’ne göre makine emniyeti, satın alma
            aşamasından itibaren başlamakta; kurulum, kullanım vb. aşamalarda
            ihtiyaçlar belirlenmekte ve gereklilikler yerine getirilmektedir.
          </p>
        </li>
        <li>
          <p>
            Her yeni makine veya ekipman ilavesinde ya da yer değişikliğinde
            risk analizleri güncellenmekte ve riskler belirlenmektedir.
          </p>
        </li>
      </ul>
      <p>
        <strong>Periyodik Kontroller ve Ölçümler</strong>
      </p>
      <ul>
        <li>
          <p>
            İş ekipmanlarının periyodik kontrolleri, ilgili kanun ve eklerine
            uygun olarak yaptırılmaktadır.
          </p>
        </li>
        <li>
          <p>
            İş Hijyeni ölçümleri kapsamında çalışma ortamında kişisel maruziyet
            ve ortam ölçümleri yaptırılarak çalışanların maruziyetleri kontrol
            edilmektedir.
          </p>
        </li>
      </ul>
      <p>
        <strong>Kişisel Koruyucu Donanım (KKD)</strong>
      </p>
      <ul>
        <li>
          <p>
            Tehlike ve riskleri elimine etmek için kişisel koruyucu donanım
            kullanımı en son başvurulan çözüm olarak benimsenmektedir.
          </p>
        </li>
        <li>
          <p>
            Kişisel koruyucu donanım kullanımı zorunlu olup, iş bazında gerekli
            KKD’ler dokümanlar ile tanımlanmaktadır.
          </p>
        </li>
        <li>
          <p>
            Kişisel koruyucu donanım seçiminde CE etiketi ve EN standartlarına
            uygunluk şartı aranmaktadır.
          </p>
        </li>
      </ul>
      <p>
        <strong>Kimyasal Yönetimi</strong>
      </p>
      <ul>
        <li>
          <p>
            Çalışanlara İSG kapsamında kimyasallar ve kimyasal riskler hakkında
            eğitimler verilmekte ve bilinçlendirme sağlanmaktadır.
          </p>
        </li>
        <li>
          <p>
            Kimyasal bulunan tüm alanlarda firmaya özel, özet Malzeme Güvenlik
            Bilgi Formları bulundurulmaktadır.
          </p>
        </li>
        <li>
          <p>
            Kimyasalların yönetimi ile ilgili prosedür mevcut olup,
            kimyasalların alımı, taşınması, depolanması ve bertarafı prosedürler
            ile kontrol altında tutulmakta ve kayıt altına alınmaktadır.
          </p>
        </li>
        <li>
          <p>
            Kimyasalların depolanması Çevre ve İSG şartlarına uygun olarak
            yapılmaktadır.
          </p>
        </li>
        <li>
          <p>
            Kimyasalların karayolu ile taşınması yasal gereklilikler
            çerçevesinde takip edilmektedir.
          </p>
        </li>
        <li>
          <p>
            Kimyasalların ve tehlikeli atıkların paketlenmesi, ambalajlanması,
            geçici depolanması, firma içi taşınması vb. tüm kurallar dokümanlar
            ile tanımlanmıştır ve denetlenmektedir.
          </p>
        </li>
        <li>
          <p>
            KKDİK ve ilgili mevzuatlar kapsamında kimyasallar değerlendirilmekte
            ve yasal şartlar takip edilmektedir.
          </p>
        </li>
      </ul>
      <p>
        <strong>Sürdürülebilirlik Yönetimi</strong>
      </p>
      <ul>
        <li>
          <p>
            İSG performansı sürdürülebilirlik hedefleri doğrultusunda sürekli
            olarak iyileştirilmektedir.
          </p>
        </li>
        <li>
          <p>ISO 45001 İSG Yönetim Sistemi Belgesi sürdürülmektedir.</p>
        </li>
        <li>
          <p>
            Sürekli iyileştirme araçları (öneri sistemi, KAIZEN, yalın 6 sigma,
            vb.) etkin şekilde kullanılmaktadır.
          </p>
        </li>
      </ul>
      <p>
        <strong>Acil Durum</strong>
      </p>
      <ul>
        <li>
          <p>
            Acil Durum El Kitabı bulunmakta olup, müşteri isteklerini de içeren;
            iş kazaları, yangın, deprem, sel, gıda zehirlenmesi, sabotaj, vb.
            belirlenen riskler detaylandırılmış olup, doküman güncellenmektedir.
          </p>
        </li>
        <li>
          <p>
            Acil durum planları ve ekipleri oluşturulmuş olup, ekiplere
            eğitimler verilmekte ve tatbikatlar yapılmaktadır.
          </p>
        </li>
        <li>
          <p>
            Yangın acil durum kapsamında değerlendirilmekte olup, bunlar ile
            ilgili talimatlar bulunmaktadır. Yangınla ilgili sistem ve
            ekipmanlar yasal şartlar ve standartlar çerçevesinde
            değerlendirilmektedir.
          </p>
        </li>
      </ul>
      <p>
        <strong>Tedarikçi ve Yüklenici Yönetimi</strong>
      </p>
      <ul>
        <li>
          <p>
            Yükleniciler İSG açısından değerlendirilmekte ve denetlenmektedir.
            Yeni çalışmaya başlanılan tedarikçiler değerlendirmeye alınmaktadır,
          </p>
        </li>
        <li>
          <p>
            Yükleniciler ile İSG şartlarını içeren sözleşmeler yapılmaktadır.
          </p>
        </li>
        <li>
          <p>
            Çalışma iş izin prosedür ve talimatları (ateşli çalışma, yüksekte
            çalışma, vb.) hazırlanmış olup, bu tarz çalışmalar başlamadan önce
            iş izni verilmekte ve daha sonra çalışma başlamaktadır,
          </p>
        </li>
        <li>
          <p>Onaylı yükleniciler ile çalışılmaktadır.</p>
        </li>
      </ul>
      <p>
        <strong>Denetim</strong>
      </p>
      <ul>
        <li>
          <p>
            İç ve dış denetimler yapılmakta, denetim sonuçları aksiyon planları
            ile takip edilmektedir.
          </p>
        </li>
      </ul>
      <p>
        <strong>Diğer</strong>
      </p>
      <ul>
        <li>
          <p>
            TÜDOKSAD, EBSO gibi üyesi olunan kuruluşların İSG çalışmalarına
            katılım sağlanmakta ve destek verilmektedir.
          </p>
        </li>
      </ul>
    </div>
  );
};

const Health = () => {
  const { t } = useTranslation();
  const language = i18next.language;
  const { lang } = useParams();

  // useEffect(() => {
  //   if (lang) {
  //       i18next.changeLanguage(lang);
  //   }
  //   const updateTitle = () => {
  //       document.title = `${t("sustainability-health")} - Cevher`;
  //     };

  //     updateTitle();

  //     const handleLanguageChanged = () => {
  //       updateTitle();
  //     };

  //     i18next.on("languageChanged", handleLanguageChanged);

  //     return () => {
  //       i18next.off("languageChanged", handleLanguageChanged);
  //     };
  //   }, [lang]);

  return (
    <div>
      <Meta
        title={t("sustainability-health")}
        description={t("sustainability-health-title")}
        lang={lang}
      />
      <Navbar />
      <div className="c-wrapper">
        <div className="c-hero">
          <div className="c-hero-background">
            <picture>
              <img
                className="c-hero-image"
                alt=""
                src={require("../../assets/hero/occupational-health-and-safety-policy.3fb5dcaf.jpg")}
              />
            </picture>
          </div>
          <div className="c-hero-body">
            <div className="c-about-caption">
              <div
                className="c-caption-section"
                style={{ color: "#fff", textAlign: "center" }}
              >
                {t("sustainability")}
              </div>
              <h1 className="c-caption-header">{t("sustainability-health")}</h1>
            </div>
          </div>
        </div>
        <div
          className="c-container c-health-content"
          style={{
            display: "flex",
            flexDirection: "column",
            paddingTop: "3rem",
            paddingBottom: "3rem",
          }}
        >
          {language === "en" ? <ISGEnglish /> : <ISGTurkish />}
        </div>

        <div className="c-container">
          <div className="c-col--offset-lg-2 c-col--lg-8">
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                width: "100%",
                justifyContent: "center",
                gap: 8,
              }}
            >
              <a
                href={
                  language === "en"
                    ? require("../../assets/certificates/Cevher_Health_EN.jpg")
                    : require("../../assets/certificates/Cevher_Health_TR.jpg")
                }
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={
                    language === "en"
                      ? require("../../assets/certificates/Cevher_Health_EN.jpg")
                      : require("../../assets/certificates/Cevher_Health_TR.jpg")
                  }
                  alt=""
                  className="c-logo"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Health;
